import { optimisedEvaluateExpression } from './evaluateExpression';
import { createExpressionEvaluator } from './indirectEval';
import type { Obj } from './recursiveUpdate';
import { recursiveUpdate } from './recursiveUpdate';

export type ShouldPreserveExpression = (value: string) => boolean;

export const getComputedData = <T>(
  data: Record<string, unknown> | string | unknown[],
  context: Record<string, unknown>,
  shouldEvaluateResult?: (result: string) => boolean,
  shouldPreserveExpression?: ShouldPreserveExpression,
  onError?: (e: unknown) => void
) => {
  // we create a closure of new function for the context, for it to be used for all evaluations in the data
  // saving us from the overhead of creating a new function for each evaluation
  const expressionEvaluator = createExpressionEvaluator(context);
  return recursiveUpdate(data, (value) => {
    if (typeof value !== 'string') return value as Obj;
    if (shouldPreserveExpression?.(value)) return value;

    return optimisedEvaluateExpression({
      context,
      expression: value,
      shouldEvaluateResult,
      expressionEvaluator,
      onError,
    }) as Obj;
  }) as T;
};
